import "./Signup_influencer.css";
import logo from "../assets/logo.png";
import Submit_button from "../components/submit_button.js";
import Header from "../components/header.js";
import { useState } from "react";
import { toast, Toast, Toaster } from "react-hot-toast";

function Signup_influencer() {
  const [email, SetEmail] = useState("");

  const handleEmailInputChange = (event) => {
    SetEmail(event.target.value);
  };

  const handleSubmit = () => {
    if (email.length === 0) {
      toast.error("Please enter your email!");
    } else {
      toast.success("email sent successfully!");
      //send email to contact@happer.fr
    }
  };

  return (
    <>
      <Header user="influencer" title="Connexion" />
      <div className="Signup_influencer">
        <Toaster toastOptions={{ duration: 2000 }} />
        <img className="Happer_image" src={logo} alt="Happer LOGO" />
        <p className="Happer_text">
          La plateforme monétisation mode <br />
          des créateurs de contenu
        </p>
        <p className="hint">
          Partager votre style et aidez votre audience a faire ses achats auprés
          de plusieur
          <br /> marque dans le domaine de la mode{" "}
        </p>
        <p className="hint">
          Devenir créateur de contenue Happer et développer vous avec une
          communauté
          <br /> de passionné mode pour maximiser les revenues de votre contenu
          digital mode.
        </p>
        <input
          type="tel"
          name="phone-number"
          value={email}
          onChange={handleEmailInputChange}
          placeholder="Votre email"
          required
        />
        <Submit_button
          title="Devenir influenceur Happer"
          onClick={handleSubmit}
        />
        <div style={{ marginBottom: "200px" }}></div>
      </div>
    </>
  );
}

export default Signup_influencer;
